module.exports = __webpack_public_path__ + "img/pro_emm_01.4205259e.png";